<mat-form-field>
    <input [(ngModel)]="date"
           [matDatepicker]="datePicker"
           [placeholder]="datePlaceholder"
           (blur)="onTouch()"
           data-cy="ui-datetime-picker-date"
           matInput>
    <mat-datepicker-toggle [for]="datePicker"
                           matSuffix></mat-datepicker-toggle>
    <mat-datepicker #datePicker
                    (closed)="onTouch()">
    </mat-datepicker>
</mat-form-field>

<mat-form-field
                class="timepicker">
    <ui-suggest [(ngModel)]="time"
                [searchable]="true"
                [clearable]="false"
                [items]="values"
                [placeholder]="timePlaceholder"
                [direction]="timePickerDirection"
                (closed)="onTouch()"
                data-cy="ui-datetime-picker-time"
                name="time">
    </ui-suggest>
</mat-form-field>
